module.exports = __webpack_public_path__ + "img/Benoit_HUET.9babe1f3.jpg";